var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0013 0.166626C7.25679 0.166626 0.167969 7.25545 0.167969 16C0.167969 24.7445 7.25679 31.8333 16.0013 31.8333C24.7458 31.8333 31.8346 24.7445 31.8346 16C31.8346 11.8007 30.1665 7.77343 27.1972 4.8041C24.2278 1.83478 20.2006 0.166626 16.0013 0.166626ZM17.5846 21.5416C17.5846 21.9789 17.2302 22.3333 16.793 22.3333H15.2096C14.7724 22.3333 14.418 21.9789 14.418 21.5416V19.9583C14.418 19.5211 14.7724 19.1666 15.2096 19.1666H16.793C17.2302 19.1666 17.5846 19.5211 17.5846 19.9583V21.5416ZM16.8402 16C17.0415 16.0014 17.2119 15.8515 17.236 15.6516L17.8694 10.5533C17.8967 10.3274 17.8255 10.1007 17.674 9.93102C17.5224 9.76131 17.3052 9.66499 17.0777 9.66664H14.9244C14.6969 9.66499 14.4797 9.76131 14.3281 9.93102C14.1766 10.1007 14.1054 10.3274 14.1327 10.5533L14.766 15.6516C14.7902 15.8515 14.9605 16.0014 15.1619 16H16.8402Z",
    fill: "#D6001A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.208b8dc72385eb8a75abad7a75f2394a.svg";
export { ForwardRef as ReactComponent };